var _path, _g, _g2, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path3, _path4, _path5, _path6, _path7, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfficency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321317832"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.5781 5.50781C44.606 5.50781 45.4141 4.69977 45.4141 3.67187C45.4141 3.19476 45.2305 2.71707 44.8633 2.38672C44.5329 2.01953 44.0921 1.83594 43.5781 1.83594C42.5865 1.83594 41.7422 2.64398 41.7422 3.67187C41.7422 4.6635 42.5502 5.50781 43.5781 5.50781ZM43.5781 3.30469C43.7249 3.30469 43.7985 3.37835 43.8354 3.41461C43.8716 3.45145 43.9453 3.52511 43.9453 3.67187C43.9453 3.8923 43.7617 4.03906 43.5781 4.03906C43.3577 4.03906 43.2109 3.85547 43.2109 3.67187C43.2109 3.45145 43.3945 3.30469 43.5781 3.30469Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 0,
    width: 3,
    height: 2
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8b143b41b8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.6543 0H47.25V1.57584H45.6543V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.25 0.734374C47.25 0.782539 47.2455 0.830137 47.2358 0.877736C47.2262 0.924767 47.2126 0.970666 47.1939 1.01543C47.1758 1.0602 47.1531 1.10213 47.1265 1.14236C47.0993 1.18259 47.0692 1.21942 47.0347 1.25342C47.0007 1.28799 46.9638 1.31802 46.9236 1.34522C46.8834 1.37185 46.8414 1.39452 46.7967 1.41265C46.7519 1.43135 46.706 1.44495 46.659 1.45458C46.6114 1.46421 46.5638 1.46875 46.5156 1.46875C46.4675 1.46875 46.4199 1.46421 46.3723 1.45458C46.3252 1.44495 46.2793 1.43135 46.2346 1.41265C46.1898 1.39452 46.1479 1.37185 46.1076 1.34522C46.0674 1.31802 46.0306 1.28799 45.9966 1.25342C45.962 1.21942 45.932 1.18259 45.9048 1.14236C45.8781 1.10213 45.8555 1.0602 45.8373 1.01543C45.8186 0.970666 45.8045 0.924767 45.7954 0.877736C45.7858 0.830137 45.7812 0.782539 45.7812 0.734374C45.7812 0.686209 45.7858 0.638611 45.7954 0.591012C45.8045 0.543981 45.8186 0.498082 45.8373 0.453317C45.8555 0.408552 45.8781 0.36662 45.9048 0.326388C45.932 0.286156 45.962 0.249324 45.9966 0.215326C46.0306 0.18076 46.0674 0.150728 46.1076 0.123529C46.1479 0.0968967 46.1898 0.0742307 46.2346 0.056098C46.2793 0.0373986 46.3252 0.0232325 46.3723 0.0141662C46.4199 0.00453321 46.4675 0 46.5156 0C46.5638 0 46.6114 0.00453321 46.659 0.0141662C46.706 0.0232325 46.7519 0.0373986 46.7967 0.056098C46.8414 0.0742307 46.8834 0.0968967 46.9236 0.123529C46.9638 0.150728 47.0007 0.18076 47.0347 0.215326C47.0692 0.249324 47.0993 0.286156 47.1265 0.326388C47.1531 0.36662 47.1758 0.408552 47.1939 0.453317C47.2126 0.498082 47.2262 0.543981 47.2358 0.591012C47.2455 0.638611 47.25 0.686209 47.25 0.734374Z",
    fill: "#13373F"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.92187 5.50781C4.94977 5.50781 5.75781 4.6635 5.75781 3.67187C5.75781 2.64398 4.9135 1.83594 3.92187 1.83594C3.40792 1.83594 2.96707 2.01953 2.63672 2.38672C2.26953 2.71707 2.08594 3.19476 2.08594 3.67187C2.08594 4.69977 2.93024 5.50781 3.92187 5.50781ZM3.66461 3.41461C3.70145 3.37835 3.77511 3.30469 3.92187 3.30469C4.1423 3.30469 4.28906 3.45145 4.28906 3.67187C4.28906 3.8923 4.1423 4.03906 3.92187 4.03906C3.70145 4.03906 3.55469 3.8923 3.55469 3.67187C3.55469 3.52511 3.62835 3.45145 3.66461 3.41461Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2,
    height: 2
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b9e89304fd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.25 0H1.84568V1.57584H0.25V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.71875 0.734374C1.71875 0.782539 1.71421 0.830137 1.70458 0.877736C1.69495 0.924767 1.68135 0.970666 1.66265 1.01543C1.64452 1.0602 1.62185 1.10213 1.59522 1.14236C1.56802 1.18259 1.53799 1.21942 1.50342 1.25342C1.46942 1.28799 1.43259 1.31802 1.39236 1.34522C1.35213 1.37185 1.3102 1.39452 1.26543 1.41265C1.22067 1.43135 1.17477 1.44495 1.12774 1.45458C1.08014 1.46421 1.03254 1.46875 0.984374 1.46875C0.936209 1.46875 0.888611 1.46421 0.841012 1.45458C0.793981 1.44495 0.748082 1.43135 0.703317 1.41265C0.658552 1.39452 0.61662 1.37185 0.576388 1.34522C0.536156 1.31802 0.499324 1.28799 0.465326 1.25342C0.43076 1.21942 0.400728 1.18259 0.373529 1.14236C0.346897 1.10213 0.324231 1.0602 0.306098 1.01543C0.287399 0.970666 0.273799 0.924767 0.264166 0.877736C0.254533 0.830137 0.25 0.782539 0.25 0.734374C0.25 0.686209 0.254533 0.638611 0.264166 0.591012C0.273799 0.543981 0.287399 0.498082 0.306098 0.453317C0.324231 0.408552 0.346897 0.36662 0.373529 0.326388C0.400728 0.286156 0.43076 0.249324 0.465326 0.215326C0.499324 0.18076 0.536156 0.150728 0.576388 0.123529C0.61662 0.0968967 0.658552 0.0742307 0.703317 0.056098C0.748082 0.0373986 0.793981 0.0232325 0.841012 0.0141662C0.888611 0.00453321 0.936209 0 0.984374 0C1.03254 0 1.08014 0.00453321 1.12774 0.0141662C1.17477 0.0232325 1.22067 0.0373986 1.26543 0.056098C1.3102 0.0742307 1.35213 0.0968967 1.39236 0.123529C1.43259 0.150728 1.46942 0.18076 1.50342 0.215326C1.53799 0.249324 1.56802 0.286156 1.59522 0.326388C1.62185 0.36662 1.64452 0.408552 1.66265 0.453317C1.68135 0.498082 1.69495 0.543981 1.70458 0.591012C1.71421 0.638611 1.71875 0.686209 1.71875 0.734374Z",
    fill: "#13373F"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 13,
    width: 7,
    height: 34
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "a1cc3f3439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.7285 13.9062H37.8211V47.0001H31.7285V13.9062Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.2344 13.9531H33.2969C32.4888 13.9531 31.8281 14.6138 31.8281 15.4219V46.2656C31.8281 46.6696 32.1585 47 32.5625 47H36.9687C37.3728 47 37.7031 46.6696 37.7031 46.2656V15.4219C37.7031 14.6138 37.0424 13.9531 36.2344 13.9531ZM36.2344 45.5312H33.2969V15.4219H36.2344V45.5312Z",
    fill: "#13373F"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 7,
    height: 26
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "2dcc988f90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.4751 21.1592H30.4226V47H24.4751V21.1592Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M28.8906 21.2969H25.9531C25.1451 21.2969 24.4844 21.9576 24.4844 22.7656V46.2656C24.4844 46.6696 24.8147 47 25.2187 47H29.625C30.029 47 30.3594 46.6696 30.3594 46.2656V22.7656C30.3594 21.9576 29.6987 21.2969 28.8906 21.2969ZM28.8906 45.5312H25.9531V22.7656H28.8906V45.5312Z",
    fill: "#13373F"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 28,
    width: 7,
    height: 19
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "df1a5b4c7f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.0771 28.5571H23.0247V46.9998H17.0771V28.5571Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.5469 28.6406H18.6094C17.8013 28.6406 17.1406 29.3013 17.1406 30.1094V46.2656C17.1406 46.6696 17.471 47 17.875 47H22.2812C22.6853 47 23.0156 46.6696 23.0156 46.2656V30.1094C23.0156 29.3013 22.3549 28.6406 21.5469 28.6406ZM21.5469 45.5312H18.6094V30.1094H21.5469V45.5312Z",
    fill: "#13373F"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 35,
    width: 7,
    height: 12
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "96ec87c89e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.67871 35.9556H15.7713V47.0001H9.67871V35.9556Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M14.2026 35.9844H11.2651C10.4571 35.9844 9.79639 36.6451 9.79639 37.4531V46.2656C9.79639 46.6696 10.1267 47 10.5308 47H14.937C15.341 47 15.6714 46.6696 15.6714 46.2656V37.4531C15.6714 36.6451 15.0107 35.9844 14.2026 35.9844ZM14.2026 45.5312H11.2651V37.4531H14.2026V45.5312Z",
    fill: "#13373F"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.4688 23.5001C13.4688 24.5648 13.6155 25.5564 13.9096 26.5112C14.3131 26.2171 14.7539 25.8868 15.1948 25.5564C15.0112 24.932 14.9375 24.2344 14.9375 23.5001C14.9375 18.9839 18.3158 15.2752 22.6853 14.7612C22.5017 14.2835 22.4648 13.7696 22.6116 13.2925C17.471 13.8433 13.4688 18.2127 13.4688 23.5001Z",
    fill: "#13373F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.30005 32.6059C7.40998 32.9 7.7035 33.0467 7.96076 33.0467C8.07069 33.0467 8.14436 33.0467 8.25428 32.9731C12.5874 31.174 22.8318 25.8498 26.9808 14.6137L27.0545 14.9809C27.1281 15.3118 27.4217 15.5685 27.752 15.5685C27.7889 15.5685 27.8625 15.5685 27.9356 15.5317C28.3396 15.4586 28.5601 15.0546 28.4864 14.6506L27.7889 11.6031C27.7152 11.3459 27.5316 11.1254 27.2749 11.0523C27.0177 10.9787 26.761 11.0523 26.5774 11.1991L24.2269 13.3654C23.9334 13.6227 23.8966 14.0998 24.1907 14.3939C24.4473 14.6874 24.925 14.7242 25.2185 14.4301L25.6226 14.0629C21.6934 24.8219 11.8531 29.8888 7.66724 31.6516C7.30005 31.7984 7.11646 32.2024 7.30005 32.6059Z",
    fill: "#13373F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M29.1841 16.5603C29.5881 16.8907 29.9921 17.2579 30.3593 17.6987V15.6424C30.2125 15.5319 30.102 15.4219 29.9553 15.312C29.8454 15.7891 29.5513 16.23 29.1841 16.5603Z",
    fill: "#13373F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M39.1719 33.3774V35.4706L40.457 36.7558C40.7874 37.0861 40.6775 37.7469 40.2366 38.1877L39.1719 39.2524V41.3088C39.2818 41.2351 39.3555 41.162 39.4291 41.0515L41.2651 39.2156C42.293 38.1877 42.3666 36.6453 41.4849 35.7273L39.1719 33.3774Z",
    fill: "#13373F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M7.961 34.5158C7.74058 34.5158 7.52015 34.479 7.30029 34.4059L6.01514 35.6911C5.09717 36.609 5.2071 38.1509 6.235 39.1793L8.07093 41.0153C8.1446 41.0884 8.25453 41.162 8.32819 41.2351V39.1793L7.26346 38.114C6.82261 37.6738 6.74951 37.0125 7.04303 36.719L9.39292 34.3691C9.50341 34.2586 9.61334 34.1118 9.68701 33.9282C9.35609 34.075 9.06256 34.1855 8.80531 34.2954C8.51178 34.479 8.25453 34.5158 7.961 34.5158Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_624_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 34
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "34742294f4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M0.25 0H47.2499V33.3443H0.25V0Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_624_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M44.9369 19.5708H41.5954C41.1177 17.4414 40.2734 15.4219 39.135 13.6228L41.4849 11.2729C42.4028 10.3549 42.2929 8.81249 41.265 7.78459L39.4291 5.94866C38.8783 5.39788 38.1802 5.10379 37.4826 5.10379C36.895 5.10379 36.3443 5.32421 35.9408 5.72823L33.5904 8.07811C31.8281 6.97655 29.8086 6.13225 27.6791 5.65457V2.31305C27.6791 1.0279 26.5039 0 25.072 0H22.4648C21.0329 0 19.8577 1.0279 19.8577 2.31305V5.65457C17.6914 6.13225 15.6719 6.97655 13.9096 8.11495L11.5591 5.76506C11.1557 5.36104 10.5681 5.14062 10.0173 5.14062C9.35601 5.14062 8.62164 5.43414 8.07086 5.98492L6.23492 7.82086C5.20702 8.84932 5.13336 10.3912 6.01506 11.3091L8.36495 13.6596C7.22655 15.4219 6.38225 17.4414 5.90457 19.5708H2.56305C1.2779 19.5708 0.25 20.7461 0.25 22.178V24.7851C0.25 26.217 1.2779 27.3923 2.56305 27.3923H5.90457C6.12499 28.4202 6.45535 29.4486 6.85937 30.4029C6.93303 30.3666 7.04296 30.2929 7.15289 30.2561C7.48381 30.1093 7.81417 29.9626 8.21818 29.779C7.851 28.8978 7.59374 27.9799 7.37331 27.0619C7.22655 26.4006 6.63894 25.9235 5.9414 25.9235H2.56305C2.08593 25.9235 1.71875 25.4096 1.71875 24.7851V22.178C1.71875 21.5541 2.12277 21.0396 2.56305 21.0396H5.90457C6.60211 21.0396 7.18972 20.5625 7.33648 19.9018C7.7405 17.9553 8.51171 16.1194 9.61327 14.4302C9.98046 13.8432 9.90679 13.072 9.42967 12.5943L7.07979 10.2444C6.74944 9.91405 6.85937 9.25334 7.30022 8.84932L9.13615 7.01338C9.39284 6.75613 9.7232 6.60937 10.0173 6.60937C10.164 6.60937 10.3845 6.6462 10.5312 6.79296L12.8811 9.14284C13.1752 9.43693 13.5424 9.58369 13.9096 9.58369C14.1663 9.58369 14.4604 9.51003 14.7171 9.36327C16.4062 8.29854 18.2422 7.52733 20.188 7.08648C20.8493 6.93972 21.3264 6.35211 21.3264 5.65457V2.31305C21.3264 1.83593 21.8404 1.46875 22.4648 1.46875H25.072C25.6958 1.46875 26.2103 1.87277 26.2103 2.31305V5.65457C26.2103 6.35211 26.6875 6.93972 27.3482 7.08648C29.2946 7.52733 31.1305 8.26171 32.8197 9.36327C33.0764 9.51003 33.3337 9.58369 33.6272 9.58369C33.9944 9.58369 34.3984 9.43693 34.6556 9.14284L37.0055 6.79296C37.1523 6.6462 37.3727 6.60937 37.5195 6.60937C37.8498 6.60937 38.1439 6.75613 38.4006 7.01338L40.2365 8.84932C40.6774 9.2896 40.7505 9.95088 40.457 10.2444L38.1071 12.5943C37.9966 12.7048 37.9235 12.8147 37.8498 12.9615C38.6579 13.476 39.1718 14.394 39.1718 15.4219V16.8169C39.6127 17.8086 39.943 18.8365 40.1635 19.9018C40.3102 20.5625 40.8978 21.0396 41.5954 21.0396H44.9369C45.414 21.0396 45.7812 21.5541 45.7812 22.178V24.7851C45.7812 25.4096 45.3772 25.9235 44.9369 25.9235H41.5954C40.8978 25.9235 40.3102 26.4006 40.1635 27.0619C39.943 28.1266 39.6127 29.1545 39.1718 30.1462V33.2673C40.3102 31.5044 41.1545 29.5217 41.5954 27.3923H44.9369C46.222 27.3923 47.2499 26.217 47.2499 24.7851V22.178C47.2499 20.7461 46.222 19.5708 44.9369 19.5708Z",
    fill: "#13373F"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficency);
export default __webpack_public_path__ + "static/media/Efficency.06ecbde6fe5c18e0801a37fc5fad924f.svg";
export { ForwardRef as ReactComponent };